// extracted by mini-css-extract-plugin
module.exports = {"title":"AlertDialog_title__JEpwO","actions":"AlertDialog_actions__CBkCh","action-button":"AlertDialog_action-button__36Qw_"};